import ICWarning from 'assets/icons/warning-icon.svg'
import CustomButton from 'components/Buttons/CustomButton'
import { useEffect, useState } from 'react'
import { AlertCircle } from 'react-feather'
import { useSelector } from 'react-redux'
import { Modal, ModalBody } from 'reactstrap'
import {
  useDeleteCategoryMutation,
  useDeleteCategoryPersonalMutation,
  useLazyGetCategoriesPersonalQuery,
  useLazyGetCategoriesQuery,
} from './payableNotesApiSlice'

const ModalDelete = ({ row, isOpen, isReceivable, toggle }) => {
  const [errMsg, setErrMsg] = useState('')

  const { ownerData } = useSelector((s) => s.dashboard)
  const { type } = useSelector((s) => s.payableNotes)

  const [deleteCategoryCompany, resultCompany] = useDeleteCategoryMutation()
  const [deleteCategoryPersonal, resultPersonal] = useDeleteCategoryPersonalMutation()
  const [getCategoriesCompany] = useLazyGetCategoriesQuery()
  const [getCategoriesPersonal] = useLazyGetCategoriesPersonalQuery()

  const deleteCategory = type === 'personal' ? deleteCategoryPersonal : deleteCategoryCompany
  const getCategories = type === 'personal' ? getCategoriesPersonal : getCategoriesCompany
  const result = type === 'personal' ? resultPersonal : resultCompany

  const handleSubmit = async () => {
    try {
      const body = {
        id: row?.id,
      }
      const resp = await deleteCategory(body).unwrap()
      if (!resp?.data?.error) {
        toggle()
        getCategories({
          type: isReceivable ? 'receivable' : 'payable',
          active: 1,
          userId: ownerData?.userId,
        })
      } else {
        throw resp
      }
    } catch (error) {
      setErrMsg(error?.data?.message ?? error?.message)
    }
  }

  useEffect(() => {
    if (!isOpen) {
      setErrMsg('')
    }
  }, [isOpen])

  return (
    <Modal centered toggle={toggle} isOpen={isOpen}>
      <ModalBody>
        <img src={ICWarning} alt="Warning Icon" />
        <h6 className="mt-4 fw-600">Hapus kategori ini?</h6>
        {errMsg && (
          <small className="text-danger">
            <AlertCircle size={15} /> {errMsg}
          </small>
        )}
        <div className="d-flex gap-3 mt-4">
          <CustomButton onClick={toggle} block outline color="secondary">
            Batal
          </CustomButton>
          <CustomButton onClick={handleSubmit} block color="danger">
            Hapus
          </CustomButton>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalDelete
